import { render } from "./samplings.vue?vue&type=template&id=1d53176a"
import script from "./samplings.vue?vue&type=script&lang=js"
export * from "./samplings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__